export default "__VITE_ASSET__DGYvMMe6__"